import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from "jquery";
import {Container, Row, Col, Card, CardTitle, CardBody, FormGroup, Label, Input, Button, ButtonGroup, Table, Modal, ModalHeader, ModalBody, TabContent, TabPane, Nav, NavItem, NavLink} from 'reactstrap';
import Notifications, {notify} from 'react-notify-toast';
import { Loader } from '../../../vibe/';
import {AppName, Version, ClientName, Api} from '../../../variables';
import {LineLoader, PageLoader, Tabs} from '../../../elements';
import API from '../../../config/API';
import {setls, upperCase,capitalizeFirst, groupByMultiple, getSortOrder, getls, getCookie} from '../../../config';
import CKEditor from 'ckeditor4-react';
import {reactLocalStorage} from 'reactjs-localstorage';
import ModalFileBrowser from '../../app/filebrowser/ModalFileBrowser';


import Menu from './menu';
import AddEmaterials from './AddEmaterials';
import EditEmaterials from './EditEmaterials';


const styles = {
	courseBtn: {
	    position: 'fixed',
		top: '51px',
		right: '0',
		zIndex: '99',
	}
}

class DeptEmaterial extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showLoader: false,
			showEditModal: false,
			showFileBrowser: false,
			btnSubmit: 'Update Page',
			btnUpload: 'Upload Content',
			aboutData: '',
			data: [],
			pageCategory: 'ematerials',
			deptId: getls('user','deptid'),
			selectedFilename: '', 
			selectedFile: '', 
			selectedUrl: '', 
			showAddModal: false,
			fileList: [],
			fileView: [],
			deptCourse: reactLocalStorage.getObject('courselist'),
			batchList: reactLocalStorage.getObject('batchlist'),
			deptEmployees: reactLocalStorage.getObject('employeelist'),
			uploadAcademicYear: '',
			editData: [],
		}
		
		this.handleTblSearch = this.handleTblSearch.bind(this);
		this.handleTblDropdownSearch = this.handleTblDropdownSearch.bind(this);
		this.modalAfterFinish = this.modalAfterFinish.bind(this);
		this.loadFileList = this.loadFileList.bind(this);
	}
	
	componentDidMount(){
		
		//this.loadPageContent();
		this.loadFileList();
	}
	
	handleFileBrowserClick(files){
		try{
			
			
			var url = files[0].data.path +'/'+ files[0].data.name;
			url= url.replace(/\/\//g, "/");
			
			this.setState({
				selectedFilename: files[0].data.name,
				selectedUrl: url
			});
			//selectedUrl: files[0].path
		}
		catch(error){
			
		}
	}
	
	
	loadFileList(){
		try{
			
			this.setState({showLoader: true});
			API.get('v1/department/ematerials/'+this.state.deptId).then(res=>{
				if(res['data'].status=='1')
				{
					this.setState({fileList: res['data'].data, fileView: res['data'].data, showLoader: false});
				}
				else
				{
					this.setState({showLoader: false});
				}
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	handleTblSearch(e){
		try{
			
			var v = upperCase(e.target.value);
			var d = this.state.fileList.filter(function(obj){
				return(upperCase(obj.filetitle).indexOf(v)>-1);
			});
			
			this.setState({fileView: d});
		}
		catch(error){
			
		}
	}
	
	handleTblDropdownSearch(e){
		try{
			
			if(e.target.value=="")
			{
				this.setState({fileView: this.state.fileList});
				return;
			}
			var v = upperCase(e.target.value);
			var d = this.state.fileList.filter(function(obj){
				return(upperCase(obj.forcourse)==v);
			});
			
			this.setState({fileView: d});
		}
		catch(error){
			
		}
	}
	
	handlefileRemove(item){
		try{
			var $this = this;
			$.confirm({
				title: 'Confirm',
				content: 'Do you want to Delete?',
				buttons: {
					Yes: function(){
						$this.confirmFileRemove(item);
					},
					No: function(){
						
					}
				}
			});
		}
		catch(error){
			
		}
	}
	
	confirmFileRemove(item){
		try{
			
			this.setState({showLoader: true});
			API.delete('v1/department/ematerial/remove/'+item.id).then(res=>{
				if(res['data'].status=='1')
				{
					var index = this.state.fileList.findIndex(function(obj){
						return((obj.id==item.id));
					});
					var s = this.state.fileList;
					s.splice(index,1);
					this.setState({fileList: s, fileView: s, showLoader: false});
					notify.show(res['data'].message,'success');
				}
				else
				{
					this.setState({showLoader: false});
					notify.show(res['data'].message,'error');
				}
			});
		}
		catch(error){
			this.setState({showLoader: false});
		}
	}
	
	modalAfterFinish(){
		
		this.setState({showAddModal: false, showEditModal: false});
		this.loadFileList();
	}
	
	handleEdit(item){
		try{
			
			this.setState({editData: item, showEditModal: true});
		}
		catch(error){
			
		}
	}
	
	getStaffName(sId){
		try{
			var d = this.state.deptEmployees.filter(function(obj){
				return(obj.id==sId);
			});
			
			return d[0].empname+' '+d[0].qualification;
		}
		catch(error){
			
		}
	}
	
	render(){
		
		let sno = 1;
		
		return(
			<div>
				
				<PageLoader loading={this.state.showLoader} />
				<LineLoader loading={this.state.showLoader} />
				
				<Menu />
				
				
				<div className="pt-50" >
				
			<Card>
				<CardBody>
					<Row>
						<Col md={7} >
							<div className="input-group" >
								<Input type="text"size="sm" placeholder="Search by  Title" onChange={this.handleTblSearch} />
								<div className="input-group-addon" >
									<span className="ion-search"></span>
								</div>
							</div>
						</Col>
						<Col md={2} >
							<Input type="select" size="sm" onChange={this.handleTblDropdownSearch} >
								<option value=""> </option>
								<option value="all" > All </option>
								<option value="ug" > UG </option>
								<option value="pg" > PG </option>
								<option value="mphil" > M.Phil </option>
							</Input>
						</Col>
						<Col md={3}>
							<div className="text-right" >
								<Button type="button" size="sm" color="warning" onClick={this.loadFileList} >
									<span className="ion-ios7-reload"></span>
								</Button>
								&nbsp;
								<Button type="button" size="sm" color="info" onClick={()=>{this.setState({showAddModal: true})}} >
									<span className="ion-android-add"></span> Add Content
								</Button>
							</div>
						</Col>
					</Row>
					<Row className="mt-10" >
						<Col md={12} >
							<Table className="tbl" >
								<thead>
									<tr>
										<th width="80" >S.No</th>
										<th>File Title</th>
										<th>Type</th>
										<th>Staff Name</th>
										<th>Category</th>
										<th width="120" >Manage</th>
									</tr>
								</thead>
								<tbody>
								{this.state.fileView.map((item,i)=>{
									return <tr key={i} >
										<td align="center" >{sno++}</td>
										<td>
										{item.externallink.length>3 ?
											<a href={item.externallink} target="_blank" >
												{item.filetitle}
											</a>
											:<a href={Api.ImageUploadPath + item.filepath.replace(Api.ImageUploadPath, '')} target="_blank" >
												{item.filetitle}
											</a>
										}
										</td>
										<td>{upperCase(item.linktype)}</td>
										<td>{this.getStaffName(item.staffid)}</td>
										<td>{upperCase(item.forcourse)}</td>
										<td align="center" >
											<Button type="button" size="xs" color="info" onClick={this.handleEdit.bind(this,item)} >
												<span className="ion-edit"></span>
											</Button>
											&nbsp;
											
											<Button type="button" size="xs" color="danger" onClick={this.handlefileRemove.bind(this,item)} >
												<span className="ion-close"></span>
											</Button>
										</td>
									</tr>;
								})
								}
								</tbody>
							</Table>
						</Col>
					</Row>
				</CardBody>
			</Card>
				
							
				</div>
				
				<Modal isOpen={this.state.showAddModal} size="xl" backdrop={true} >
					<ModalHeader toggle={()=>{this.setState({selectedFilename: '', selectedFile: '', selectedUrl: '', showAddModal: false})}} >
						Upload Content
					</ModalHeader>
					<ModalBody>
						
							<AddEmaterials pageCategory={this.state.pageCategory}
							atFinish={this.modalAfterFinish} />
							
					</ModalBody>
				</Modal>
				
				<Modal isOpen={this.state.showEditModal} size="xl" backdrop={true} >
					<ModalHeader toggle={()=>{this.setState({selectedFilename: '', selectedFile: '', selectedUrl: '', showEditModal: false})}} >
						Edit Uploaded Content
					</ModalHeader>
					<ModalBody>
						
							<EditEmaterials pageCategory={this.state.pageCategory}
							editData={this.state.editData}
							atFinish={this.modalAfterFinish} />
							
					</ModalBody>
				</Modal>
			
																
			</div>
		);
	}

}

export default DeptEmaterial;
